// 超级管理员
export const SUPPERADMIN = "superAdmin";

// 用户相关权限
export const USERPERMISSION = {
  ADD: "add",
  EDIT: "edit"
};

export const pageParams = {
  pageSizes: [10, 30, 50, 100],
  pageSize: 10,
  pageNum: 1,
  total: 0
};


// WEBPACK FOOTER //
// ./src/common/constant.js